import { Box, Stack, Typography } from "@mui/material";
import DownArrow from "src/assets/svg-icons/red-down-arrow.svg";
import UpArrow from "src/assets/svg-icons/green-up-arrow.svg";
import sarIcon from "src/assets/svg-icons/sar.svg";

interface IProps {
  label: string;
  value: string;
  percentage: number;
  isMoney?: boolean;
}

const StatisticsBox = ({ label, value, percentage, isMoney }: IProps) => {
  return (
    <Box
      padding={"20px 27px"}
      bgcolor={"#242424"}
      borderRadius={"12px"}
      height={"100%"}
    >
      <Stack gap={2}>
        <Typography
          color={"#B0B0B0"}
          fontSize={"16px"}
          fontWeight={500}
          lineHeight={1}
        >
          {label}
        </Typography>
        <Stack direction={"row"} gap={3}>
          <Typography fontSize={"18px"} fontWeight={600} lineHeight={1}>
            {isMoney ? (
              <>
                <img height={14} src={sarIcon} alt="" />{" "}
              </>
            ) : null}
            {value}
          </Typography>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <Typography
              color={
                percentage < 0
                  ? "#C02020"
                  : percentage === 0
                  ? "textPrimary"
                  : "#16AA75"
              }
              fontSize={"18px"}
              fontWeight={500}
              lineHeight={1}
            >
              {percentage}%
            </Typography>
            {percentage !== 0 && (
              <img src={percentage < 0 ? DownArrow : UpArrow} alt="" />
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default StatisticsBox;
